export enum MessageType {
  SystemMsg = 'system',
  ErrorMsg = 'error',
  AiMsg = 'ai',
  UserMsg = 'user',
  InterruptMsg = 'interrupt',
  WorkflowSavedMsg = 'workflow_saved',
  WorkflowTestMsg = 'workflow_test',
}

export type Message = {
  id?: string
  author?: string
  message: string
  type?: MessageType
  pass_to_human?: boolean
  thinking?: string
  feedback?: FeedbackType
  commited?: boolean
  reasoning?: any
  tool_calls?: any
}

export enum FeedbackType {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
}

export type MessageRequest = {
  query: string
  model?: string | null
  thread_id?: string | null
  action_response?: string | null
  action_name?: string | null
  feedback?: string | null
  application_id?: string | null
  app_version_id?: string | null
}

export type SendFeedbackPayload = {
  agentId: string
  feedbackType: FeedbackType
  requestId: string
  sessionId: string
  reason?: string
  message?: string
}

// Deep Agent configuration types
export interface DeepAgentToolConfig {
  name: string
  description?: string
  reason?: string
}

export interface DeepAgentSubagentConfig {
  name: string
  description?: string
  async?: boolean
  graph_id?: string
  url?: string
}

export interface DeepAgentToolkitConfig {
  toolkit_name: string
  selected_tools?: string[]
  reason?: string
}

export interface DeepAgentKnowledgeBaseConfig {
  knowledge_base_name: string
  reason?: string
}

export interface DeepAgent {
  id: string
  application_id: string
  app_version_id?: string
  name: string
  description?: string
  system_prompt?: string
  tools?: DeepAgentToolConfig[]
  subagents?: DeepAgentSubagentConfig[]
  toolkits?: DeepAgentToolkitConfig[]
  knowledge_bases?: DeepAgentKnowledgeBaseConfig[]
  model_name?: string
  temperature?: number
  additional_props?: any
  status?: string
  is_active: boolean
  created_at?: string
  updated_at?: string
  created_by?: any
  modified_by?: any
}

export interface CreateDeepAgentPayload {
  name: string
  description?: string
  system_prompt?: string
  tools?: DeepAgentToolConfig[]
  subagents?: DeepAgentSubagentConfig[]
  toolkits?: DeepAgentToolkitConfig[]
  knowledge_bases?: DeepAgentKnowledgeBaseConfig[]
  model_name?: string
  temperature?: number
  additional_props?: any
  application_id: string
  app_version_id?: string
}

export interface UpdateDeepAgentPayload {
  name?: string
  description?: string
  system_prompt?: string
  tools?: DeepAgentToolConfig[]
  subagents?: DeepAgentSubagentConfig[]
  toolkits?: DeepAgentToolkitConfig[]
  knowledge_bases?: DeepAgentKnowledgeBaseConfig[]
  model_name?: string
  temperature?: number
  additional_props?: any
  status?: string
  is_active?: boolean
}
